// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"OrderFormatSelectionModal_modalBody__neM70"};